<template>
  <div>
    <v-data-table
      v-if="items.length <= 0"
      :items-per-page="5"
      item-key="name"
      class="elevation-1 table-header"
      loading
      :headers="headersNotfound"
      :items="itemNotfound"
      loading-text="Loading... Please wait"
      hide-default-footer
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
        /> </template
    ></v-data-table>
    <v-data-table
      v-else
      dense
      :items-per-page="5"
      :headers="headers"
      :items="items"
      class="elevation-1 table-header hoverable_row"
      height="auto"
      :search="this.search"
      hide-default-footer
      @click:row="handleRowClick"
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
        />
        <v-dialog v-model="dialog" max-width="750px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Selected Item Information </span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <div v-for="(header, idx) in headers" :key="idx">
                    <v-col cols="auto" sm="auto" md="auto">
                      <v-text-field
                        color="black"
                        v-if="checkIsEmpty(curItem[header.value])"
                        v-model="emptyItem"
                        :label="header.text"
                        :readonly="true"
                      ></v-text-field>
                      <v-text-field
                        color="black"
                        v-else
                        v-model="curItem[header.value]"
                        :label="header.text"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <!-- <v-spacer></v-spacer> -->
              <v-btn color="blue darken-1" text @click="close"> OK </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template
        v-for="header in headers"
        v-slot:[`item.${header.value}`]="{ item }"
      >
        <template v-if="isBoolean(item[header.value])">
          <div class="checkbox_container" v-bind:key="item[header.value]">
            <v-checkbox
              v-bind:key="item[header.value]"
              v-model="item[header.value]"
              :true-value="true"
              :false-value="false"
              light
              disabled
              color="black"
            ></v-checkbox>
          </div>
        </template>
        <template v-else>
          {{ item[header.value] }}
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script scoped>
export default {
  props: [
    "tableItems",
    "tableHeaders",
    "isRequest",
    "isAsset",
    "parent",
    "search",
  ],
  data() {
    return {
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      curItem: {},
      dialog: false,
      emptyItem: " ",
    };
  },
  computed: {
    items() {
      return this.tableItems;
    },
    headers() {
      return this.tableHeaders;
    },
  },
  methods: {
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    close() {
      this.dialog = false;
    },
    handleRowClick(item) {
      if (this.parent === "equipment-id" || this.parent == "N") {
        this.$emit("selectedEquipmentId", item);
        this.$emit("selected", item);
      } else if (this.parent === "equipment-serial") {
        this.$emit("selectedEquipmentSerial", item);
      } else {
        this.curItem = item;
        this.dialog = true;
      }
    },
    isBoolean(value) {
      return typeof value === "boolean";
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/standard.scss";
</style>
